import { formatDate } from './formatDate';

const MINUTE = 60000;
// Past a month "400 days ago" is harder to read than the date itself.
const MAX_RELATIVE_DAYS = 30;

/**
 * "Just now" / "5 minutes ago" / "3 hours ago" / "Yesterday" / "4 days ago",
 * then dd/mm/yyyy beyond 30 days.
 * A timestamp in the future (client clock behind the server) clamps to
 * "Just now" rather than printing a negative age.
 */
export function relativeTime(iso, now = new Date()) {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return '';
  const minutes = Math.max(0, Math.floor((now.getTime() - t) / MINUTE));
  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;
  const days = Math.floor(hours / 24);
  if (days === 1) return 'Yesterday';
  if (days > MAX_RELATIVE_DAYS) return formatDate(iso);
  return `${days} days ago`;
}

/** How long something has been waiting on the viewer, in whole days. */
export function waitingLabel(iso, now = new Date()) {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return '';
  const days = Math.max(0, Math.floor((now.getTime() - t) / (24 * 60 * MINUTE)));
  if (days === 0) return 'Today';
  return `Waiting ${days} day${days === 1 ? '' : 's'}`;
}
